import React from 'react'
//Helpers
import { RealEstateDataPageComponentData } from 'types'
import useQueryDevelopment from '@hooks/useQueryDevelopment'
import { getTours } from '@helpers/helper.properties'
import { Container } from 'react-bootstrap'
import SliderDetail from '@components/sliderDetail/1'
import './index.scss'

interface ExternalProps {
  developmentID: string
}

type CombinedProps = RealEstateDataPageComponentData & ExternalProps

const DevelopmentTours_1 = ({
  developmentID,
  global_data,
  upperCaseLink,
  alignCenter,
  titleSecondary,
}: CombinedProps) => {
  const { data: allDevelopmentData, isLoading } = useQueryDevelopment(
    developmentID,
    global_data.pageConfig.keys.tokko,
  )

  console.log(getTours(allDevelopmentData))

  return (
    (getTours(allDevelopmentData)?.length > 0 || isLoading) && (
      <section className="development-sliders a">
        <SliderDetail
          developmentID={allDevelopmentData?.id}
          type={'tours'}
          global_data={global_data}
          alignCenter={alignCenter}
          titleSecondary={titleSecondary}
          upperCaseLink={upperCaseLink}
        />
      </section>
    )
  )
}

export default DevelopmentTours_1
